<template>
  <div :class="['asc-chip', compact ? 'asc-chip--compact' : null]">
    <div
      :class="[
        'asc-chip-content',
        disabled ? 'asc-chip-content--disabled' : null,
      ]"
      :title="tooltip"
    >
      {{ text }}
    </div>
    <template v-if="!closeHidden">
      <v-btn icon :disabled="disabled" @click="handleClose">
        <v-icon size="16">mdi-close</v-icon>
      </v-btn>
    </template>
  </div>
</template>

<script>
export default {
  name: 'AscChip',

  props: {
    text: {
      type: [String, Number],
      default: '',
    },
    tooltip: {
      type: [String, Number],
      default: '',
    },
    value: {
      type: [String, Number],
      default: undefined,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    closeHidden: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleClose(event) {
      event.preventDefault()
      event.stopPropagation()
      if (this.onClose) {
        this.onClose(this.value)
      }
    },
  },
}
</script>

<style lang="scss">
.asc-chip {
  align-items: center;
  background-color: $gray-100;
  cursor: default;
  display: inline-flex;
  height: 22px;
  line-height: 18px;
  min-width: 36px;
  max-width: 132px;
  outline: none;
  overflow: hidden;
  padding-left: 4px;
  position: relative;
  text-decoration: none;
  transition-duration: 0.28s;
  transition-property: box-shadow, opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  vertical-align: middle;
  white-space: nowrap;

  .asc-chip-content {
    line-height: 18px;
    font-size: 14px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-right: 4px;
    color: $primary-black;

    &--disabled {
      cursor: not-allowed;
    }
  }

  .v-btn {
    color: $gray-500;
    height: 16px;
    justify-content: flex-end;
    width: 16px;
    margin: 2px 2px 2px 0;
  }
}

.asc-chip--compact {
  .asc-chip-content {
    font-size: 12px;
  }
}
</style>
